{
	"abilities": "Abilities",
	"ability_admins_manage": "Manage administrators",
	"ability_catalog_manage": "Manage catalog",
	"ability_notifications_manage": "Manage notifications",
	"ability_users_impersonate": "Impersonate users",
	"ability_users_manage": "Manage users",
	"account": "Account",
	"account_copy": "Manage your profile and interface preferences.",
	"account_preferences": "Account preferences",
	"action_failed": "The action could not be completed.",
	"action_failed_copy": "No changes were applied. Check your connection and try again.",
	"active_cards": "Active cards",
	"active_expansions": "Active expansions",
	"activity": "Activity",
	"administrators": "Administrators",
	"administrators_load_error": "Unable to load administrators.",
	"app_name": "Seal Ledger",
	"appearance": "Appearance",
	"archive": "Archive",
	"archive_card": "Archive card?",
	"archive_card_copy": "This hides the card and its printings from active catalog views. Existing records remain intact.",
	"archive_expansion": "Archive expansion?",
	"archive_expansion_copy": "This hides the expansion from active catalog views. Existing records remain intact.",
	"archive_printing": "Archive printing?",
	"archive_printing_copy": "This hides the printing from active catalog views. Existing records remain intact.",
	"authenticator_devices": "Authenticator devices",
	"backoffice": "Backoffice",
	"ban_user": "Ban user",
	"ban_user_copy": "This signs the user out everywhere and prevents new sign-ins until the ban is lifted.",
	"block_optional": "Block (optional)",
	"cancel": "Cancel",
	"card": "Card",
	"card_category": "Card type",
	"card_number_optional": "Card number (optional)",
	"cards": "Cards",
	"catalog": "Catalog",
	"catalog_record_not_found": "Can't find the printing?",
	"catalog_search_empty": "No active printings match this search.",
	"catalog_search_error": "Unable to search the catalog.",
	"catalog_search_for_match_copy": "Choose an existing printing manually when the suggested match is incomplete or incorrect.",
	"catalog_reference": "Catalog reference",
	"catalog_load_error": "Unable to load catalog records.",
	"catalog_quality_hint": "Catalog quality is a daily habit.",
	"choose_image": "Choose image",
	"close_navigation": "Close navigation",
	"collapse_navigation": "Collapse navigation",
	"cost_optional": "Cost (optional)",
	"create_card": "Create card",
	"create_catalog_record": "Create a catalog record",
	"create_catalog_record_copy": "Create the missing card or printing, then return here to complete the match.",
	"create_expansion": "Create expansion",
	"create_printing": "Create printing",
	"dashboard": "Overview",
	"disabled": "Disabled",
	"display_name": "Display name",
	"edit": "Edit",
	"edit_abilities": "Edit abilities",
	"edit_expansion": "Edit expansion",
	"email": "Email",
	"empty_activity": "No activity recorded yet.",
	"empty_administrators": "No administrators found.",
	"empty_cards": "No active cards yet.",
	"empty_expansions": "No active expansions yet.",
	"empty_printings": "No active printings yet.",
	"empty_queue": "No provider products need catalog reconciliation.",
	"empty_users": "No users found.",
	"enabled": "Enabled",
	"expand_navigation": "Expand navigation",
	"expansion": "Expansion",
	"expansion_code": "Expansion code",
	"expansion_kind": "Expansion type",
	"expansions": "Expansions",
	"image_asset_id_optional": "Image asset ID (optional)",
	"image_upload_failed": "The image could not be uploaded. Try again.",
	"image_uploaded": "Image uploaded",
	"invite_admin": "Invite administrator",
	"language": "Language",
	"loading": "Loading catalog…",
	"loading_administrators": "Loading administrators...",
	"loading_user_details": "Loading user details…",
	"loading_users": "Loading users...",
	"manage_catalog": "Manage catalog",
	"match_error": "Unable to confirm the match.",
	"match_error_copy": "The provider product is still unresolved. Please try again.",
	"match_this_printing": "Match this printing",
	"mfa_code": "Verification code",
	"mfa_copy": "Choose one of the available verification methods to continue to the backoffice.",
	"mfa_email": "Email code",
	"mfa_enabled": "MFA enabled",
	"mfa_error": "We could not verify that code. Try again or choose another method.",
	"mfa_passkey": "Passkey",
	"mfa_recovery": "Recovery code",
	"mfa_send_email": "Send email code",
	"mfa_title": "Verify your identity",
	"mfa_totp": "Authenticator app",
	"mfa_unavailable": "This verification method is not available in this client yet.",
	"mfa_use_passkey": "Use passkey",
	"mfa_verify": "Verify and continue",
	"mobile_push": "Mobile push",
	"name_optional": "Name (optional)",
	"needs_catalog": "Needs catalog",
	"new_card": "New card",
	"new_expansion": "New expansion",
	"new_printing": "New printing",
	"no_suggested_match_copy": "No automatic suggestion was found. Search the existing catalog below before creating a new record.",
	"next": "Next",
	"no": "No",
	"notification_preferences": "Notification preferences",
	"notification_preferences_hint": "Resolved delivery settings for this user.",
	"open_navigation": "Open navigation",
	"open_queue": "Open queue",
	"overview": "Overview",
	"overview_copy": "Keep the catalog tidy and resolve provider products before they become friction for collectors.",
	"passkeys": "Passkeys",
	"power_optional": "Power (optional)",
	"previous": "Previous",
	"printed_number_optional": "Printed number (optional)",
	"printings": "Printings",
	"profile": "Profile",
	"profile_load_error": "Unable to load your profile.",
	"provider_product": "Provider product",
	"provider_version": "Provider version",
	"queue_copy": "{{count}} provider products need a canonical printing.",
	"queue_load_error": "Unable to load the catalog queue.",
	"recent_attention": "Needs your attention",
	"reconciliation": "Catalog queue",
	"recovery_codes": "Recovery codes",
	"review_match": "Review match",
	"review_match_copy": "Review the suggestions, or search the existing catalog and choose the exact printing manually.",
	"review_suggested_printings": "Review suggested printings",
	"refresh": "Refresh",
	"retry": "Try again",
	"retry_copy": "Check your connection and retry the request.",
	"reset_filters": "Reset filters",
	"save_changes": "Save changes",
	"search": "Search catalog",
	"search_queue": "Search provider products",
	"search_existing_printings": "Search existing printings",
	"search_users": "Search users",
	"send_invite": "Send invite",
	"series_optional": "Series (optional)",
	"session": "Session",
	"session_copy": "Sign out from this browser when you are done.",
	"sign_out": "Sign out",
	"suggestion": "Suggested match",
	"theme_dark": "Dark",
	"theme_light": "Light",
	"theme_system": "System",
	"unban_user": "Lift ban",
	"unban_user_copy": "This restores the user's ability to sign in.",
	"unknown_ip": "Unknown IP",
	"upload_card_image": "Upload card image",
	"upload_card_image_hint": "JPEG, PNG, or WebP up to 10 MB.",
	"uploading_image": "Uploading…",
	"user_activity_hint": "Recent account and sign-in events.",
	"user_detail_error": "User details could not be loaded.",
	"user_security": "User security",
	"users": "Users",
	"users_load_error": "Unable to load users.",
	"variant": "Variant",
	"welcome": "Good morning, curator.",
	"yes": "Yes",
	"actions": "Actions",
	"active": "Active",
	"all_card_categories": "All card types",
	"all_expansion_kinds": "All expansion types",
	"all_languages": "All languages",
	"all_mfa_states": "All MFA states",
	"all_statuses": "All statuses",
	"all_variants": "All variants",
	"all_verification_states": "All verification states",
	"announced": "Announced",
	"administrator": "Administrator",
	"banned": "Banned",
	"block": "Block",
	"card_number": "Card number",
	"cost": "Cost",
	"deleted": "Deleted",
	"email_verification": "Email verification",
	"filter_by_card_category": "Filter by card type",
	"filter_by_email_verification": "Filter by email verification",
	"filter_by_expansion_kind": "Filter by expansion type",
	"filter_by_language": "Filter by language",
	"filter_by_mfa": "Filter by MFA",
	"filter_by_status": "Filter by status",
	"filter_by_variant": "Filter by variant",
	"image": "Image",
	"mfa": "MFA",
	"mfa_disabled": "MFA disabled",
	"overview_queue_copy": "Open the queue to review provider products that still need a canonical catalog printing.",
	"overview_load_error": "Unable to load overview statistics.",
	"power": "Power",
	"pending": "Pending",
	"printed_number": "Printed number",
	"release_date": "Release date",
	"released": "Released",
	"series": "Series",
	"select_card": "Select a card",
	"select_expansion": "Select an expansion",
	"status": "Status",
	"suggested_matches": "Suggested matches",
	"unnamed_administrator": "Unnamed administrator",
	"unnamed_user": "Unnamed user",
	"user": "User",
	"verified": "Verified",
	"unverified": "Unverified",
	"go_overview": "Go to overview",
	"not_found": "Page not found",
	"not_found_copy": "This backoffice page does not exist or is no longer available.",
	"unexpected_error": "Something went wrong.",
	"unexpected_error_copy": "The page could not be displayed. Try again or return to the overview."
}
